import apiRequest from "./apiRequest";

export const getCropTypes = async (token) => {
  const cropTypes = await apiRequest.get("v2/farms/crop_types/list", {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return cropTypes.data.data.crop_types;
};

export const updateField = async (fieldId, params, token) => {
  const field = await apiRequest.put(`/v2/fields/${fieldId}`, params, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return field.data;
};

export const deleteField = async (fieldId, token) => {
  const field = await apiRequest.delete(`/v2/fields/${fieldId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return field.data;
};

export const getLegendImg = async (url, token) => {
  const response = await apiRequest.get(url, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    responseType: "blob",
  });

  return response;
};

export const getField = async (fieldId, token) => {
  const field = await apiRequest.get(`/v2/fields/${fieldId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return field.data;
};
